import * as Sentry from '@sentry/browser';
import { Auth } from 'aws-amplify/lib/index';
import fetch from 'isomorphic-unfetch';

async function GetJwtToken() {
  let jwtToken;
  await Auth.currentSession().then((session: any) => {
    jwtToken = session.accessToken.jwtToken;
  });
  return jwtToken;
}

export async function handleErrors(response: Response) {
  if (!response.ok) {
    let resBody = await response.json();
    throw resBody;
  }
  return response;
}

export function captureError(err: Error): any {
  if (process.env.REACT_APP_ENV === 'LOCAL') {
    console.error(err);
  } else {
    Sentry.captureException(err);
  }
}

export function fetchWrapper(
  url: string,
  init: RequestInit = {},
  json: boolean = true,
) {
  return GetJwtToken()
    .then((jwtToken) => {
      init.headers = new Headers(
        json
          ? {
              access_token: jwtToken,
              'Content-Type': 'application/json',
            }
          : {
              access_token: jwtToken,
            },
      );
      return fetch(url, init);
    })
    .then(handleErrors);
}
